import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21 5c0 1.657-1.343 3-3 3-.7395 0-1.4164-.26748-1.9394-.71098L8.94752 11.4383C8.98197 11.6203 9 11.808 9 12s-.01803.3797-.05248.5617l7.11308 4.1493C16.5836 16.2675 17.2605 16 18 16c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3c0-.192.018-.3797.0525-.5617L7.93939 14.289C7.41644 14.7325 6.73949 15 6 15c-1.657 0-3-1.343-3-3s1.343-3 3-3c.73949 0 1.41644.26748 1.93939.71099l7.11311-4.14931C15.018 5.37974 15 5.19198 15 5c0-1.657 1.343-3 3-3s3 1.343 3 3z",
    fill: "currentColor"
  }));
});